<template>
	<div>
		<div class="d-flex align-items-center">
			<el-form inline ref="form" :model="searchform">

					<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0 mr-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
					</el-form-item>
						<el-form-item  class="mb-0 mr-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
						    </el-date-picker>
					</el-form-item>
          
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
            
					</el-form-item>
			</el-form>
       
		
	
	</div>
		<!-- 数据统计 -->
		<el-row :gutter="20">
			<el-col :span="spanRow" v-for="(item,index) in counts"
			:key="index">
				
					<div class="d-flex align-items-center mb-1 position-relative" :class="item.color" style=" border-radius:5px;height:100px">
						<div class="position-absolute text-white" style="right:10px;top:10px;"><h6 class="text-white">{{item.title}}</h6></div>
						<i class="h4 mb-0  text-center mr-3 ml-3 bg-white" style="width: 40px;height: 40px;line-height: 40px;display:inline-block;border-radius:3px" :class="[item.textcolor,item.icon]">
						</i>
						<div>
							<h4 class="mb-1 text-white">{{item.num}}</h4>
							<h6 class="text-white">{{item.desc}}</h6>
						</div>
					</div>
				
			</el-col>
		</el-row>
		
	 
		
		
		<el-row :gutter="20" class="my-3" v-loading="loading">
			<el-col :span="spanRow">
				<el-card class="box-card" shadow="">
				<div slot="header" class="clearfix">
					<h6 class="text-center mb-0">{{$t('msg.입금')}}</h6>
						
					</div>
					<el-table
					:data="tableIn"
					height="650"
					:empty-text="$t('tableText.데이타가없습니다')"
					style="width: 100%">
					
					<el-table-column
					  prop="level"
					  :label="$t('msg.등급')" width="45" align="center">
					    <template slot-scope="scope">
				           <span v-if="scope.row.io_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
				            <span v-if="scope.row.io_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
				            <span v-if="scope.row.io_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
				             <span v-if="scope.row.io_id!=scope.row.a_code && scope.row.io_id!=scope.row.b_code && scope.row.io_id!=scope.row.c_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
				         </template>
					</el-table-column>

					<el-table-column
					  prop="io_id"
					  :label="$t('nav.아이디')" align="center">
					   <template slot-scope="scope">
            
				             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer">{{scope.row.io_id}} ({{scope.row.io_in_name}})</span>
				        </template>
					</el-table-column>
					<el-table-column
					  prop="io_money"
					  :label="$t('msg.입금금액')" align="center">
					  <template slot-scope="scope">{{ formatMoney(scope.row.io_money)}}</template>
					</el-table-column>
					
					<el-table-column
					  prop="io_update"
					  :label="$t('msg.확인시간')" align="center" width="150">
					</el-table-column>
					

				  </el-table>
				</el-card>
			</el-col>
			<el-col :span="spanRow">
				<el-card class="box-card" shadow="">
					<div slot="header" class="clearfix">
							<h6 class="text-center mb-0">{{$t('msg.출금')}}</h6>
						
					</div>
					
				<el-table
					:data="tableOut"
					height="650"
					:empty-text="$t('tableText.데이타가없습니다')"
					style="width: 100%">
						<el-table-column
					  prop="level"
					  :label="$t('msg.등급')" 
					  width="45" align="center">
					   <template slot-scope="scope">
				           <span v-if="scope.row.io_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
				            <span v-if="scope.row.io_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
				            <span v-if="scope.row.io_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
				             <span v-if="scope.row.io_id!=scope.row.a_code && scope.row.io_id!=scope.row.b_code && scope.row.io_id!=scope.row.c_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
				         </template>
					</el-table-column>

					<el-table-column
					  prop="io_id"
					  :label="$t('nav.아이디')" align="center">
					   <template slot-scope="scope">
            
				             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer">{{scope.row.io_id}} ({{scope.row.io_in_name}})</span>
				        </template>
					</el-table-column>
					<el-table-column
					  prop="io_out_money"
					  :label="$t('msg.출금금액')" 
					  align="center">
					   <template slot-scope="scope">{{ formatMoney(scope.row.io_out_money)}}</template>
					</el-table-column>
					
					<el-table-column
					  prop="io_update"
					 :label="$t('msg.확인시간')" align="center">
					</el-table-column>
					

				  </el-table>
					
					
				</el-card>
			</el-col>
			<el-col :span="spanRow">
				<el-card class="box-card" shadow="">
				<div slot="header" class="clearfix">
					<h6 class="text-center mb-0">{{$t('msg.알충전')}}</h6>
						
					</div>
					<el-table
					:data="tableain"
					height="650"
					:empty-text="$t('tableText.데이타가없습니다')"
					style="width: 100%">
					
	                <el-table-column
					  prop="level"
					   :label="$t('msg.등급')" width="45" align="center">
					   <template slot-scope="scope">
				           <span v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
				            <span v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
				            <span v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
				             <span v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
				         </template>
					</el-table-column>

					<el-table-column
					  prop="mem_id"
					  :label="$t('nav.아이디')"  align="center">
					   <template slot-scope="scope">
            
				             <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}} ({{scope.row.mem_name}})</span>
				        </template>
					</el-table-column>

					<el-table-column
					  prop="money1"
					  :label="$t('tableText.금액')"
					   align="center">
					   <template slot-scope="scope">{{ formatMoney(scope.row.money1)}}</template>
					</el-table-column>
					<el-table-column
					  prop="regdate"
					  :label="$t('tableText.처리시간')"
					  align="center">
					</el-table-column>

				  </el-table>
				</el-card>
			</el-col>
			<el-col :span="spanRow">
				<el-card class="box-card" shadow="">
					<div slot="header" class="clearfix">
							<h6 class="text-center mb-0">{{$t('msg.알환전')}}</h6>
						
					</div>
					
				<el-table
					:data="tableaout"
					height="650"
					:empty-text="$t('tableText.데이타가없습니다')"
					style="width: 100%">
					 
					  <el-table-column
					  prop="level"
					   :label="$t('msg.등급')" width="45" align="center">
					   <template slot-scope="scope">
				           <span v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
				            <span v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
				            <span v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
				             <span v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
				         </template>
					</el-table-column>

					<el-table-column
					  prop="mem_id"
					   :label="$t('nav.아이디')" align="center">
					   <template slot-scope="scope">
            
				             <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}} ({{scope.row.mem_name}})</span>
				        </template>
					</el-table-column>

					<el-table-column
					  prop="money1"
					  :label="$t('tableText.금액')"
					   align="center">
					   <template slot-scope="scope">{{ formatMoney(scope.row.money1)}}</template>
					</el-table-column>
					<el-table-column
					  prop="regdate"
					  :label="$t('tableText.처리시간')" align="center">
					</el-table-column>

				  </el-table>
					
					
				</el-card>
			</el-col>
		</el-row>
	
	</div>
</template>

<script>
	import layer from '../../components/common/layer.vue';
	import layerNew from '../../components/common/layer-new.vue';
	export default {
		 components: {
				      layer,layerNew
				    },
		data() {
			return {
				spanRow:6,
				loading:false,
				time:'',
				admin_id:window.sessionStorage.getItem('admin_id'),
				domain:window.sessionStorage.getItem('domain'),
				  ulevel:window.sessionStorage.getItem('level'),
				user_in:'',
				user_out:'',
				pt_in:'',
				pt_out:'',
				bet:'',
				loging:'',
				searchform:{
					time:[],
    				keyword:'',
    				searchOptions:[
             
			             {
			              label:this.$i18n.t("msg.전체"),
			              value:''
			            } 
		        ],
		       
		        value:'',
    			},
    			 pickerOptions: {
    			},
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
				tableIn:[],
				tableOut:[],
				tableain:[],
				tableaout:[],
				counts: [
					{ icon:"el-icon-coin",desc:this.$i18n.t("msg.총입금"),title:this.$i18n.t("msg.입금"),num:"-",color:"bg-primary",textcolor:"text-primary" },
					{ icon:"el-icon-s-finance",desc:this.$i18n.t("msg.총출금"),title:this.$i18n.t("msg.출금"),num:"-",color:"bg-success",textcolor:"text-success" },
					{ icon:"el-icon-s-order",desc:this.$i18n.t("msg.총배팅"),title:this.$i18n.t("msg.배팅"),num:"-" ,color:"bg-danger",textcolor:"text-danger"},
					{ icon:"el-icon-s-data",desc:this.$i18n.t("msg.총롤링"),title:this.$i18n.t("msg.롤링"),num:"-",color:"bg-dark",textcolor:"text-dark" },
				],
				
			}
		},
		
		created(){

			//判断宽度

			console.log('screen.width',screen.width)

			if(screen.width<900)
			{
             //手机
             this.spanRow = 12
			}

		

		

	        

	        
	          this.searchform.searchOptions=[{
	              label:this.$i18n.t("msg.전체"),
	              value:''
	            },
	            {
	              label:this.$i18n.t("msg.매장"),
	              value:'c_code'
	            },
	            {
	              label:this.$i18n.t("msg.총판"),
	              value:'a_code'
	            }
	            ,
	            {
	              label:this.$i18n.t("msg.부본"),
	              value:'b_code'
	            },
	            {
	              label:this.$i18n.t("msg.회원"),
	              value:'mem_id'
	            }
	            ]
	            
	        
			this.getDashboard()
		},
		mounted() {
		
		},
		methods: {
				searchEvent(){
                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }
this.currentPage=1;
    			this.getDashboard();

    		},
			 openModel(id){
			          if(this.admin_id=='soft10')
			           {
			                this.$layer.iframe({
			                type: 2,
			                title: '',
			                content: {
			                    content: layerNew,
			                    parent: this,
			                    data:{
			                    info:{id:id},
			                    layerid:'id'
			                    }
			                  
			                },
			                shadeClose: false,
			                maxmin:true,
			                shade: false,
			                  area: ['990px', '700px'],
			             
			             });
			              return;
			           }
			            this.$layer.iframe({
			            type: 2,
			            title: '',
			            content: {
			                content: layer,
			                parent: this,
			                data:{
			                info:{id:id},
			                layerid:'id'
			                }
			              
			            },
			            shadeClose: false,
			            maxmin:true,
			            shade: false,
			            area: ['830px', '680px'],
			         
			        });
			        },
			getDashboard(){
				let s_time="";
                let e_time="";

               if(this.searchform.time.length>0)
	               {
	                  s_time=this.searchform.time[0];
	                  e_time=this.searchform.time[1];
	               }
				   this.loading =true
    			   let token=window.sessionStorage.getItem('user');
		           let urls=this.domain+'/admin/dashboard?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword
		          
		    
		          this.$axios({
		                  method:'get',
		                  url:urls,
		                  'Accept': 'application/json',
		                   headers: { 'Authorization': 'Bearer ' + token },
		                
		               
		            }).then((response) =>{ 

		            	this.loading =false

		              if(response.data.code==200)
		              {
                       
		                      //console.log('dashboard=',response.data.data.in)
		                      let item = response.data.data
		                      this.user_in = item.user_in
		                      this.user_out = item.user_out
		                      this.pt_in = item.pt_in
		                      this.pt_out = item.pt_out
		                      this.bet = item.bet
		                      this.loging = item.loging
		                      this.counts[0].num = this.formatMoney(this.user_in + this.pt_in)
		                      this.counts[1].num = this.formatMoney(this.user_out + this.pt_out)
		                      this.counts[2].num = this.formatMoney(this.bet)
		                      this.counts[3].num = this.formatMoney(this.loging)


		                      this.counts[0].desc = response.data.time+this.$i18n.t("msg.총입금");
		                      this.counts[1].desc = response.data.time+this.$i18n.t("msg.총출금");
		                      this.counts[2].desc = response.data.time+this.$i18n.t("msg.총배팅");
		                      this.counts[3].desc = response.data.time+this.$i18n.t("msg.총롤링");

		                      this.tableIn = item.in
		                      this.tableOut = item.out
		                      this.tableain = item.ain
		                   	  this.tableaout = item.aout
		              }else
		              {
		              	  this.user_in = ''
		                      this.user_out = ''
		                      this.pt_in = ''
		                      this.pt_out = ''
		                      this.bet = ''
		                      this.loging = ''
		                      this.counts[0].num = ''
		                      this.counts[1].num = ''
		                      this.counts[2].num = ''
		                      this.counts[3].num = ''


		                      this.counts[0].desc = this.$i18n.t("msg.총입금");
		                      this.counts[1].desc = this.$i18n.t("msg.총출금");
		                      this.counts[2].desc = this.$i18n.t("msg.총배팅");
		                      this.counts[3].desc = this.$i18n.t("msg.총롤링");

		                      this.tableIn = []
		                      this.tableOut = []
		                      this.tableain = []
		                   	  this.tableaout = []

		              	  this.$message.error(response.data.msg);
		              }

		            		 
		               
		            }).catch((error) =>{
		              

		               this.$message.error(error);
		               
		                //console.log('error',error.response)       //请求失败返回的数据
		               
		            })
			}
			
		},
	}
</script>

<style>
.bg-dark{
	background-color:#767676!important
}
.text-dark{
	color:#767676!important
}
.el-card__header{
	padding:8px 10px;background-color:#e5e2e2;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue